import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogTechnicalBottleneck() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update meta tags
    document.title = 'The Technical Bottleneck: How Small Firms Win Big Contracts | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'You have the crew, but do you have the drawings? Learn how outsourcing your Senior Detailer role allows a 5-person team to compete like a 50-person firm in Vancouver construction market.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'construction business growth Vancouver, small construction firm scaling, AutoCAD outsourcing BC, technical documentation contractor, construction detailing services, formwork layout specialist, Vancouver construction contracts, Burnaby commercial projects, Surrey high-rise construction');
    }

    // Add Schema.org Article markup
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'The Technical Bottleneck: How Small Firms Win Big Contracts in Vancouver',
      description: 'You have the crew, but do you have the drawings? Learn how outsourcing your Senior Detailer role allows a 5-person team to compete like a 50-person firm.',
      author: {
        '@type': 'Person',
        name: 'Matthew Beltrame',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: `${window.location.origin}/logo.png`,
        },
      },
      datePublished: '2026-02-10',
      dateModified: '2026-02-10',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': window.location.href,
      },
    });

    if (!document.head.querySelector('script[data-schema="blog-technical-bottleneck"]')) {
      script.setAttribute('data-schema', 'blog-technical-bottleneck');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-technical-bottleneck"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
